var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderAlignmentLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67529 3C4.04795 3.00016 4.35059 3.3026 4.35059 3.67529V20.3247C4.35059 20.6974 4.04795 20.9998 3.67529 21C3.3025 21 3 20.6975 3 20.3247V3.67529C3 3.3025 3.3025 3 3.67529 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 7.62451C20.3283 7.62451 20.9997 8.29631 21 9.12451V15C21 15.8284 20.3284 16.5 19.5 16.5H9C8.17157 16.5 7.5 15.8284 7.5 15V9.12451C7.50026 8.29631 8.17174 7.62451 9 7.62451H19.5ZM9.75 9C9.33579 9 9 9.33579 9 9.75V14.25C9 14.6642 9.33579 15 9.75 15H18.75C19.1642 15 19.5 14.6642 19.5 14.25V9.75C19.5 9.33579 19.1642 9 18.75 9H9.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderAlignmentLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/builder-alignment-left.a04ec1c18a118df4e4b0ccf31ab57b8e.svg";